import type { FaireProductEntity } from "../../entity_types/product";

export const p_4mhxfh9jy3: FaireProductEntity = {
  token: "p_4mhxfh9jy3",
  type: "product",
  name: "Crystal Candle, Calming Paradise - Pack of 6",
  brandToken: "b_brgwq19hx1",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/6769f762a75bdd19bbd2999e55c867ce732d5a82abd6111e6dc8f3ce4f21a438.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34cb1cf988bcc37f460c882e0f4e98ccf1598d4d5ae267d8adce7f8114a73cfd.jpeg",
    "https://cdn.faire.com/fastly/b061c067c337bfaf96cb99c367554393de971ccaed02a1145c90105af5ab42ef.jpeg",
  ],
  priceDollars: 63,
  description:
    "CC-C44\nThe Earths Elements Wellness Calming Paradise Crystal Candle is 100% organic soy wax combined with essential oils and fragrance blends.\n\nSize: 7.1oz/200g 50 hours burn time.\n\nOnly sold in packs of 6.\n\nAquamarine: The calming influence of aquamarine extends to its ability to reduce stress and enhance relaxation.\nElevate Mother's Day gifting with a thoughtful wellness item from our collection!\n\nOpalite: Opalite is prized for its ability to promote emotional balance and inner peace. It helps alleviate stress, anxiety, & mood swings by calming the mind & soothing turbulent emotions.\n\nIt comes elegantly packaged and ready to delight anyone who appreciates the beauty of nature and the power of holistic well-being.\n\nSlight discoloration or yellowing may occur because our candles are made with 100% natural soy wax and organic essential oils that don't contain synthetic additives, stabilizers, or artificial dyes! Natural variations are a beautiful reminder that your candle is clean, non-toxic, and all natural.",
  tags: [],
  msrpDollars: 126,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:13.891Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
